import React, { useEffect, useRef, useState } from 'react';
import {
  Stack,
  CssBaseline,
} from '@mui/material';
import Box from '@mui/joy/Box';
import { useLocation, useNavigate } from 'react-router-dom';
import { PostUI } from '../Post/PostUI';
import TopNavBar from '../../Components/TopNavigation/TopNavBar';
import BottomModal from '../../Components/BottomModel';
import Comments from '../Post/Comments';

interface PostDetailScreenProps {
  posts?: any[];
  selectedIndex?: number;
  onBack?: () => void;
}

const PostDetailScreen: React.FC<PostDetailScreenProps> = ({
  posts: propPosts,
  selectedIndex: propSelectedIndex,
  onBack: propOnBack,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedPostRef = useRef<HTMLDivElement>(null);
  const [shareBottomModelOpen, setShareBottomModelOpen] = useState<boolean>(false);
  const [selectedPostId, setSelectedPostId] = useState<string>('');
  
  // Get data from navigation state or props
  const navigationState = location.state as { posts?: any[]; selectedIndex?: number; userData?: any } | undefined;
  const posts = propPosts || navigationState?.posts || [];
  const selectedIndex = propSelectedIndex ?? navigationState?.selectedIndex ?? 0;
  
  // Scroll to selected post on component mount
  useEffect(() => {
    if (selectedPostRef.current && selectedIndex >= 0) {
      // Small delay to ensure the component is fully rendered
      setTimeout(() => {
        selectedPostRef.current?.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }, 100);
    }
  }, [selectedIndex]);
  
  const handleBack = () => {
    if (propOnBack) {
      propOnBack();
    } else {
      navigate(-1); // Go back to previous page
    }
  };


  const ShareBottomModel = () => {
    return (
      <BottomModal
        open={shareBottomModelOpen}
        onClose={() => { setShareBottomModelOpen(false); setSelectedPostId(''); }}
        title="Comments"
        children={<Comments postId={selectedPostId} />}
      />
    );
  };
  
  return (
    <>
      <CssBaseline />
      <TopNavBar
        title='Posts & Shorts'
        canGoBack
        onBackClick={handleBack}
      />

      {/* Content - identical structure to main Post component */}
      <Box sx={{ p: 2 }}>
        {posts.length > 0 ? (
          <Stack spacing={4}>
            {posts.map((post, idx) => (
              <Box
                key={post?.id || post?._id || idx}
                ref={idx === selectedIndex ? selectedPostRef : null}
              >
                <PostUI
                  item={post}
                />
              </Box>
            ))}
          </Stack>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
            <div>No posts found</div>
          </Box>
        )}
      </Box>
      <ShareBottomModel />
    </>
  );
};

export default PostDetailScreen;